export const validateFormat = (rule, value, { ...props } = {}) => {
	const rules = {
		'email': /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
		'text': /^[a-z A-Z]+$/,
		'numeric': /^[0-9]+$/,
		'noSpecialChars': /^[a-zA-Z0-9]+$/,
		'length': new RegExp(`^.{${props?.min || 5},${props?.max || 100 }}$`),
		'h:mm': /^([0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/,
		'yyyy-MM-dd': /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/,
		'yyyy/MM/dd': /^\d{4}\/(0[1-9]|1[0-2])\/(0[1-9]|[12]\d|3[01])$/,
		'MM-dd-yy': /^(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])-\d{2}$/,
		'yyyy-MM-dd HH:mm:ss': /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])\s([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/,
		'yyyy/MM/dd HH:mm:ss': /^\d{4}\/(0[1-9]|1[0-2])\/(0[1-9]|[12]\d|3[01])\s([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/,
		'MM-dd-yy HH:mm:ss': /^(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])-\d{2}\s([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/,
		'MM/dd/yy HH:mm:ss': /^(0[1-9]|1[0-2])\/(0[1-9]|[12]\d|3[01])\/\d{2}\s([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/,
		'yyyy-MM-ddTHH:mm:ss.SSSZ': /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])T([01]\d|2[0-3]):([0-5]\d):([0-5]\d)\.\d{3}Z$/,
		'yyyyMMdd': /^[0-9]{8}$/,
		'dd/MM/yyyy HH:mm:ss': /^(0[1-9]|[12]\d|3[01])\/(0[1-9]|1[0-2])\/\d{4}\s([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/,
		'MM/dd/yyyy HH:mm:ss': /^(0[1-9]|1[0-2])\/(0[1-9]|[12]\d|3[01])\/\d{4}\s([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/,
	}
	if (!Object.keys(rules).some((r) => r === rule)) {
		console.error(`Rule ${rule} not defined`)
		return false
	}
	return rules[rule].test(value)
}
